import React, { useState } from "react";
import { useNavigateStore } from "../../../stepFlowHooks/useNavigateStore";
import { useCustomBrandingAssetStore } from "../../../hooks/useCustomBrandingAsset";
import { TermsOfServiceModal } from "../../../components/presession/TermsOfServiceModal";
import { WebcamModal } from "../../../components/presession/WebcamModal";
import { StepId } from "../../../enums/navigation";
import { useCheckWebcamModal } from "./useCheckWebcamModal";
import { StepFlowGate } from "../../Navigator/StepFlowGate";

// TODO [LOWA-30534] From https://tiny.amazon.com/jkibijre
export const PostSignInStep = () => {
    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );

    const {
        showWebcamModal,
        hideWebcamModal,
        isWebcamModalReady,
    } = useCheckWebcamModal();

    const hasTermsOfService = useCustomBrandingAssetStore(
        (store) => store.hasTermsOfService
    );
    const [termsOfServiceAccepted, setTermsOfServiceAccepted] = useState(false);

    // Terms of service modal
    if (hasTermsOfService && !termsOfServiceAccepted) {
        return (
            <TermsOfServiceModal
                onCancel={() => {
                    setTermsOfServiceAccepted(false);
                    navigateToSignInStep();
                }}
                onProceed={() => {
                    setTermsOfServiceAccepted(true);
                }}
            />
        );
    }

    if (showWebcamModal) {
        return <WebcamModal dismissWebcamModal={hideWebcamModal} />;
    }

    return (
        <StepFlowGate
            isCompleted={isWebcamModalReady}
            completedStepId={StepId.POST_SIGN_IN}
        />
    );
};
